"use client";

import { useTheme } from "next-themes";

export type BadgeTextTheme = "light" | "dark";

/**
 * Цвет текста бейджа под тему. Раньше учитывал ещё фоновые темы
 * «Полночь»/«Рассвет» — они убраны (KAN-1247), остались светлая и тёмная.
 */
export function useBadgeTextTheme(): BadgeTextTheme {
  const { resolvedTheme } = useTheme();
  return resolvedTheme === "dark" ? "dark" : "light";
}
